import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import usePageMeta from '../hooks/usePageMeta';
import '../styles/static-pages.css';

const APP_BASE_URL = process.env.REACT_APP_APP_URL || 'https://risqly.net';

function AccessDenied() {
  usePageMeta({
    title: 'Access Denied',
    noindex: true,
  });

  const location = useLocation();
  const navigate = useNavigate();
  const { logout } = useAuth0();
  
  const companyName = location.state?.companyName || 'This company';
  const message = location.state?.message || 'This company is limited to select email addresses. Please contact your administrator for access.';

  const handleLogout = () => {
    logout({ returnTo: APP_BASE_URL });
  };

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <div className="static-page">
      <Header />
      
      <main className="static-main">
        <div className="static-container">
          <div className="static-icon error-icon">
            <span className="material-symbols-outlined">block</span>
          </div>
          
          <h1>Access Denied</h1>
          
          <p className="static-description">
            {message}
          </p>

          <div className="static-details">
            <p><strong>What does this mean?</strong></p>
            <p>
              {companyName} uses admin-controlled access, which means only specific email addresses 
              authorized by the company administrator can access the dashboard.
            </p>
            <p>
              If you believe you should have access, please contact your company administrator 
              and request to be added to the authorized users list.
            </p>
          </div>

          <div className="static-actions">
            <button onClick={handleLogout} className="btn btn-primary">
              Log Out
            </button>
            <button onClick={handleGoHome} className="btn btn-secondary">
              Go to Home
            </button>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default AccessDenied;
